// @deprecated use ButtonType instead
enum ButtonTypes {
    LARGE_POSITIVE = 'large-positive',
    LARGE_NEGATIVE = 'large-negative',
    STANDARD_POSITIVE = 'positive',
    STANDARD_NEGATIVE = 'negative',
    SMALL_POSITIVE = 'small-positive',
    SMALL_NEGATIVE = 'small-negative',
    LINK = 'link',
    LARGE_LINK = 'large-link',
    ACTION = 'action',
    ICON = 'icon',
    ICON_NEGATIVE = 'icon-dark',
    SMALL_ICON = 'small-icon',
}

export type ButtonSizes = 'large' | 'small' | 'standard';

export type ButtonType = 'positive' | 'negative' | 'link' | 'action' | 'icon' | 'icon-dark' | 'icon-negative';

export type StandardButtonTypes =
    | ButtonTypes.STANDARD_POSITIVE
    | ButtonTypes.STANDARD_NEGATIVE
    | ButtonTypes.LARGE_POSITIVE
    | ButtonTypes.LARGE_NEGATIVE
    | 'positive'
    | 'negative';

export type LinkButtonTypes = ButtonTypes.LINK | ButtonTypes.LARGE_LINK | 'link';

export type SmallButtonTypes = ButtonTypes.SMALL_NEGATIVE | ButtonTypes.SMALL_POSITIVE | 'negative' | 'positive';

export type IconButtonTypes =
    | ButtonTypes.ICON
    | ButtonTypes.ICON_NEGATIVE
    | ButtonTypes.SMALL_ICON
    | 'icon'
    | 'icon-dark'
    | 'icon-negative';

export default ButtonTypes;
